export default __webpack_public_path__ + "assets/29c517fbbdd0ab93225e874d8b2f052a.svg";